import SyosSeat from '../SyosSeat';


/**
 * @typedef SeatClientRectContainerData
 * @property {number} scale
 * @property {ClientRect} clientRect
 */

/**
 * @typedef Container
 * @property { () => SeatClientRectContainerData } getSeatClientRectContainerData
 */


class SeatClientRectProvider {
  /**
   * @param {Container} container
   */
  constructor(container) {
    this.container = container;
  }

  /**
   * @param {SyosSeat} seat
   * @returns {ClientRect}
   */
  get(seat) {
    const { scale, clientRect: containerRect } = this.container.getSeatClientRectContainerData();

    const top = (seat.y * scale) + containerRect.top;
    const left = (seat.x * scale) + containerRect.left;

    const size = SyosSeat.GRID_UNIT_SIZE * scale;

    return {
      top,
      bottom: top + size,
      left,
      right: left + size,
      width: size,
      height: size,
    };
  }
}


export default SeatClientRectProvider;



// WEBPACK FOOTER //
// ./src/syos/utils/SeatClientRectProvider.js